import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { Disabled, DisabledOutlineButton } from "../../../../Constant";
import { DISABLE_BUTTONS_LIST, DISABLE_OUTLINE_BUTTONS } from "../../../../Data/Buttons/DefaultStyle";
import { Btn } from "../../../../AbstractElements";
import CommonFlateButton from "../Common/CommonFlatButton";

const FlatDisabledOutlineButtons = () => {
    return (
        <Card>
          <CommonCardHeader title={DisabledOutlineButton} span={DISABLE_OUTLINE_BUTTONS} />
          <CardBody className="btn-showcase">
            <Btn disabled outline color="primary" className="btn-square">{Disabled}</Btn>
            {DISABLE_BUTTONS_LIST.map((data, index) => (
              <CommonFlateButton key={index} item={data} disabled={true} outline={true}/>
            ))}
          </CardBody>
        </Card>
      );
};

export default FlatDisabledOutlineButtons;
